import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Heart, Loader2 } from "lucide-react";
import MiniHeader from "@/components/site/MiniHeader";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WatchPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    axios.get(`${API}/watch/${token}`).then((r) => setData(r.data)).catch(() => setGone(true));
  }, [token]);

  if (gone) {
    return (
      <div className="min-h-screen"><MiniHeader />
        <div data-testid="watch-unavailable" className="max-w-xl mx-auto px-6 py-32 text-center">
          <h1 className="serif text-4xl font-light text-[#F5F0E8]">This link is no longer available</h1>
          <p className="mt-4 text-[#A0988E] spectral">Please ask the family for a new link.</p>
        </div>
      </div>
    );
  }
  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-[#C5A55A]" /></div>;

  return (
    <div data-testid="watch-page" className="min-h-screen">
      <MiniHeader />
      <main className="max-w-5xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
        <div className="overline mb-4">In loving memory</div>
        <h1 data-testid="watch-loved-one-name" className="serif text-4xl sm:text-6xl font-light leading-[1.05] italic text-[#E6B89C]">{data.loved_one_name}</h1>
        <p className="mt-4 text-[#A0988E] spectral">A tribute film, shared with you by the family.</p>
        <div className="mt-10 rounded-[22px] overflow-hidden border border-[rgba(212,175,55,0.25)] shadow-2xl shadow-black/60 bg-black">
          <video data-testid="watch-player" src={`${API}/watch/${token}/stream`} controls playsInline preload="metadata"
                 controlsList="nodownload" className="w-full aspect-video" />
        </div>
        <p className="mt-16 text-center text-[#A0988E] spectral italic flex items-center justify-center gap-2">
          <Heart size={14} className="text-[#C5A55A]" /> Made with care by <a href="/" className="underline decoration-[#C5A55A]/40 hover:text-[#F5F0E8]">Eternal Legacy Tributes</a>
        </p>
      </main>
    </div>
  );
}
